<!--
 * @Descripttion: 企业信息
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <BaseDialog
    title="信息"
    :model-value="true"
    :show-close="true"
    width="400px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :beforeClose="onCancel"
    :cancel-btn-config="{
      show: false
    }"
    :before-confirm="onCancel"
    :confirm-btn-config="{
      show: true,
      content: '确定'
    }"
  >
    <BaseTextContent>
      <div class="item-wrap" v-if="isCompany">
        <BaseSvg class="icon" iconClass="gongshi"></BaseSvg>
        {{ info.entpName }}
      </div>
      <!-- 1 个人 3 个体 -->
      <div class="item-wrap" v-else-if="isIndividual">
        <BaseSvg class="icon" iconClass="getihu"></BaseSvg>
        {{ info.individualName }}
      </div>
      <div class="item-wrap">
        <BaseSvg class="icon" iconClass="renyuan"></BaseSvg>
        {{ info.name }}
      </div>
      <div class="item-wrap">
        <BaseSvg class="icon" iconClass="shouji"></BaseSvg>
        {{ maskPhone(info.phone) }}
      </div>
    </BaseTextContent>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import {
  withDefaults,
  defineProps,
  defineEmits,
  onMounted,
  ref,
  computed
} from 'vue';
import { BaseDialog, BaseTextContent } from 'xrk-components';
import { BaseSvg } from '@/components/base/base-svg/index';
import { maskPhone } from '@/utils/formatter';
import { getContractUserInfo } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    id: number;
    type: number;
    partyType: string;
    typeOfPartyAAndPartyB: number;
    contractId: string;
  }>(),
  {}
);
const emits = defineEmits(['remove']);
const info = ref<any>({});
const isIndividual = computed(() => +info.value.type == 3);
const isCompany = computed(() => +info.value.type == 2);

onMounted(() => {
  getContractUserInfo({
    id: props.id,
    type: props.type,
    typeOfPartyAAndPartyB: props.typeOfPartyAAndPartyB,
    contractId: props.contractId
  }).then(res => {
    info.value = res.data;
  });
});

const onCancel = () => {
  emits('remove');
};
</script>
<style lang="scss" scoped>
.item-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
